"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.settings.title': 'Open Settings',
    'shortcuts.settings.description': 'Open the settings panel to configure your preferences',
};
